import { useAuth } from '../context/AuthContext.jsx';
import { useTheme } from '../context/ThemeContext.jsx';
import './login.css';

function RiesterWordmark() {
  return (
    <svg viewBox="0 0 138 34" fill="currentColor" aria-label="RIESTER">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.46121 33.596H0V7.62529H17.4096V11.7013H4.46121V33.596Z" />
      <path d="M22.125 0C20.587102 0 19.412109 1.1173772 19.412109 2.6972656 19.412109 4.277144 20.587102 5.3964844 22.125 5.3964844 23.662798 5.3964844 24.837891 4.277144 24.837891 2.6972656 24.837891 1.1173772 23.662798 0 22.125 0zM20.027344 7.625 20.027344 33.595703 24.228516 33.595703 24.228516 7.625 20.027344 7.625z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M31.4316 21.4331V21.7793C31.5839 26.721 34.7104 30.1837 39.6794 30.1837C43.3644 30.1837 46.237 28.2504 47.1074 24.8886H51.3583C50.3355 30.0827 46.0339 33.9062 39.9913 33.9062C32.157 33.9062 27.0356 28.5606 27.0356 20.6179C27.0356 12.6752 32.0554 7.32951 39.4255 7.32951C46.7955 7.32951 51.6122 11.961 51.8153 19.6512C51.8153 20.1721 51.7718 20.7302 51.725 21.2968L51.7156 21.4102L51.7137 21.4331H31.4316ZM47.3033 17.9631H31.6855C32.0917 13.7356 35.6316 10.9871 39.469 10.9871C43.8214 10.9871 46.8971 13.4831 47.3033 17.9631Z" />
      <path d="M75.2892 26.0573C75.2892 30.8979 70.6321 33.899 64.8435 33.899C58.0827 33.899 53.4257 30.7392 53.3241 25.0401H57.6257C57.7781 28.0917 60.4911 30.3352 64.8435 30.3352C68.5285 30.3352 71.1399 28.7554 71.1399 26.3603C71.1399 23.0995 68.2746 22.847 64.3792 22.3853C58.5397 21.6711 53.8827 20.5024 53.8827 15.0991C53.8827 10.3666 58.2351 7.25737 64.1253 7.30787C70.0663 7.35837 74.368 10.1069 74.7742 15.5103H70.4726C70.1679 12.8627 67.7088 10.8788 64.1253 10.8788C60.5418 10.8788 58.032 12.4082 58.032 14.8033C58.032 17.6529 60.7957 18.0136 64.5896 18.4681C70.5306 19.1823 75.2892 20.3004 75.2892 26.0573Z" />
      <path d="M88.4625 29.7798H91.9154V33.596H88.049C83.0292 33.596 81.2375 31.4029 81.2375 26.822V11.4415H74.5058V7.62529H94.8387V11.4415H85.4376V26.7715C85.4376 28.9574 86.2065 29.7725 88.4625 29.7725V29.7798Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M97.53 21.5196V21.8731C97.6823 26.8148 100.809 30.2775 105.778 30.2775C109.463 30.2775 112.335 28.3442 113.206 24.9824H117.457C116.434 30.1765 112.132 34 106.09 34C98.2554 34 93.134 28.6544 93.134 20.7116C93.134 12.7689 98.1538 7.4233 105.524 7.4233C112.894 7.4233 117.711 12.0547 117.914 19.745C117.914 20.3006 117.864 20.8985 117.814 21.5038L117.812 21.5268H97.5372L97.53 21.5196ZM113.402 18.0569H97.7839C98.1901 13.8294 101.73 11.0808 105.567 11.0808C109.92 11.0808 112.995 13.5769 113.402 18.0569Z" />
      <path d="M120.59 33.596H125.052V11.7013H138V7.62529H120.59V33.596Z" />
    </svg>
  );
}

function GoogleGlyph({ mono }: { mono?: boolean }) {
  if (mono) {
    return (
      <svg className="g-on" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09zM12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23zM5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62zM12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
      </svg>
    );
  }
  return (
    <svg className="g-mono" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
    </svg>
  );
}

export default function LoginScreen() {
  const { authError } = useAuth();
  const { isDark, toggle } = useTheme();

  return (
    <main className="lg-stage">
      <div className="lg-topbar" />

      <button className="lg-theme" onClick={toggle} aria-label="toggle theme">
        <span className="sw" />
        <span>{isDark ? 'dark' : 'light'}</span>
      </button>

      {/* ── editorial brand panel ── */}
      <section className="lg-brand">
        <div className="lg-brand-top lg-anim d1">
          <RiesterWordmark />
          <span className="lg-lockup-div" />
          <span className="lg-lockup-tag">font library</span>
        </div>

        <div className="lg-brand-mid">
          <h2 className="display lg-anim d3">every font we own,<br /><em>in one place</em></h2>
          <p className="lg-anim d4">Upload, browse, and activate every typeface the agency has licensed — auto-tagged, health-checked, and synced to your machine.</p>
        </div>

        <div className="lg-brand-foot lg-anim d5">
          <div className="col">
            <div className="k">formats</div>
            <div className="v">otf · ttf · woff · woff2</div>
          </div>
          <div className="col">
            <div className="k">features</div>
            <div className="v">smart search · brand kits · activation</div>
          </div>
          <div className="col">
            <div className="k">access</div>
            <div className="v">riester staff only</div>
          </div>
        </div>
      </section>

      {/* ── sign-in column ── */}
      <section className="lg-auth">
        <div className="lg-auth-inner">
          <div className="lg-eyebrow lg-anim d2">sign in</div>
          <h1 className="lg-anim d2">Welcome back</h1>
          <p className="lg-lede lg-anim d3">Continue with your <b>@riester.com</b> Google account to reach the font library.</p>

          {authError && (
            <div className="lg-err" role="alert">
              <span className="dot" />
              <div>
                <span className="lbl">sign-in error</span>
                <span className="msg">{authError}</span>
              </div>
            </div>
          )}

          <a href="/api/auth/google" className="lg-gbtn lg-anim d4">
            <span className="gwrap">
              <GoogleGlyph />
              <GoogleGlyph mono />
            </span>
            <span>Sign in with Google</span>
          </a>

          <div className="lg-hint lg-anim d5">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
              <rect x="4" y="10.5" width="16" height="10" /><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
            </svg>
            <span>access is restricted to verified @riester.com accounts</span>
          </div>

          <div className="lg-foot lg-anim d6">
            <div className="note">riester internal tool — authorized personnel only</div>
          </div>
        </div>
      </section>
    </main>
  );
}
